module.exports = __webpack_public_path__ + "img/34c9f8a.jpg";